import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import { TileFooter } from '@cmd/ui-components';
import { Box } from '@interstate/components/Box';
import { Card } from '@interstate/components/Card';
import { useInterstateToken } from '@interstate/components/InterstateThemeProvider';
import { Typography } from '@interstate/components/Typography';
import { DEFAULT_WEB_COMPONENT_TILE_SIZE } from '../webComponentUtils';
import useTileSize from './useTileSize';
import WebComponentTileMask from './WebComponentTileMask';
const WebComponentTile = ({ children, dataPeriodLabel, error, isLoading, noData, onResize, title, description, lastUpdated, source, stylesLoading, }) => {
    const [tileSize, setTileSize] = useState(DEFAULT_WEB_COMPONENT_TILE_SIZE);
    const getToken = useInterstateToken();
    const ref = useRef(null);
    useTileSize(ref, (size) => {
        setTileSize(size);
        if (onResize) {
            onResize(size);
        }
    });
    return (_jsx(Card, { ref: ref, header: (_jsxs(Box, { children: [_jsx(Typography, { sx: {
                        lineHeight: getToken(`base.type.size.${tileSize === 'large' ? '3xl' : '2xl'}`),
                    }, variant: ['medium', 'large'].includes(tileSize) ? 'strong-md' : 'strong-sm', children: title }), _jsx(Typography, { sx: {
                        lineHeight: getToken(`base.type.size.${tileSize === 'large' ? 'xl' : 'lg'}`),
                    }, variant: tileSize === 'large' ? 'body-sm' : 'body-xs', children: description })] })), content: (_jsxs(Box, { sx: {
                display: 'flex',
                flexDirection: 'column',
                flex: 1,
                marginTop: getToken(`base.space.${tileSize === 'small' ? '20' : '30'}`),
                position: 'relative',
                minHeight: 50,
                minWidth: 50,
                height: '100%',
            }, children: [_jsx(WebComponentTileMask, { error: error, isLoading: isLoading, noData: noData, size: tileSize }), !stylesLoading && children] })), footer: (_jsx(TileFooter, { dataPeriod: dataPeriodLabel, lastUpdated: lastUpdated, size: tileSize === 'xsmall' ? 'small' : tileSize, sourceLabel: source })), sx: {
            border: 'none',
            '& div.card-media-header-content-container': {
                flex: 1,
                '& div.card-header-content-container': {
                    flex: 1,
                    padding: tileSize === 'large' ? 2 : (tileSize === 'medium' ? 1.5 : 1),
                },
            },
            display: 'flex',
            flexDirection: 'column',
        } }));
};
export default WebComponentTile;
